(function () {
  function openSizeGuide(modal) {
    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    var closeButton = modal.querySelector('[data-nfp-size-guide-close]');
    if (closeButton) closeButton.focus();
  }

  function closeSizeGuide(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function initSizeGuide() {
    document.querySelectorAll('[data-nfp-size-guide-open]').forEach(function (button) {
      if (button.dataset.nfpReady === 'true') return;
      button.dataset.nfpReady = 'true';

      button.addEventListener('click', function () {
        var wrapper = button.closest('.nfp-size-guide');
        var modal = wrapper ? wrapper.querySelector('[data-nfp-size-guide-modal]') : null;
        openSizeGuide(modal);
      });
    });

    document.querySelectorAll('[data-nfp-size-guide-modal]').forEach(function (modal) {
      if (modal.dataset.nfpReady === 'true') return;
      modal.dataset.nfpReady = 'true';

      modal.addEventListener('click', function (event) {
        if (event.target === modal || event.target.closest('[data-nfp-size-guide-close]')) {
          closeSizeGuide(modal);
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('[data-nfp-size-guide-modal].is-open').forEach(closeSizeGuide);
    });
  }

  function findProductSubmitButton() {
    return document.querySelector(
      'form[action*="/cart/add"] button[name="add"], product-form button[name="add"], .product-form__submit'
    );
  }

  function scrollToProductForm() {
    var target =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form') ||
      document.querySelector('.product__info-container');

    if (!target) return;

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  function initMobileAtc() {
    var sticky = document.querySelector('[data-nfp-mobile-atc]');
    if (!sticky || sticky.dataset.nfpReady === 'true') return;

    sticky.dataset.nfpReady = 'true';

    var button = sticky.querySelector('[data-nfp-mobile-atc-button]');
    var offset = parseInt(sticky.getAttribute('data-scroll-offset'), 10) || 450;

    function updateVisibility() {
      if (window.innerWidth > 749) {
        sticky.classList.remove('is-visible');
        return;
      }

      if (window.scrollY > offset) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    }

    if (button) {
      button.addEventListener('click', function () {
        var submitButton = findProductSubmitButton();

        if (submitButton && !submitButton.disabled) {
          submitButton.click();
        } else {
          scrollToProductForm();
        }
      });
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    updateVisibility();
  }

  function initAll() {
    initSizeGuide();
    initMobileAtc();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();